module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "clearfix"
  }, [_c('h3', {
    staticClass: "fas_title"
  }, [_vm._v("本周流行")]), _vm._v(" "), _vm._l((_vm.clList), function(cl, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": cl.img
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cl_title"
    }, [_vm._v(_vm._s(cl.title) + " ")])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7fcdc850", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7fcdc850","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/pclientfas.vue
// module id = 128
// module chunks = 0